import { Alloy } from './use-alloy';

export type IdentityResponse = { identity: { ECID: string }; edge: { regionId: number } };

export async function getIdentityData(alloy: Alloy) {
  try {
    const { identity: alloyIdentity } = await Promise.race<IdentityResponse>([
      alloy<IdentityResponse>('getIdentity'),
      new Promise((_, reject) => {
        setTimeout(() => {
          reject(new Error('Timeout'));
        }, 10000);
      }),
    ]);
    return alloyIdentity;
  } catch (error) {
    console.error('Error in alloy call', error);
    return null;
  }
}
